module.exports = __webpack_public_path__ + "static/HBR_card-hover-2a12c8caa34cfe9e02bb665458f4e1d9.png";